// extracted by mini-css-extract-plugin
module.exports = {"textBox":"_ccaa4e4"};